import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyOwnerComponent } from '../property-owner/property-owner.component';
import { MatDialog } from '@angular/material/dialog';
import { HomeService } from '../_services/home.service';
import { LoadingService } from '../_services/loading.service';
import { LoginPopupComponent } from '../login-popup/login-popup.component';
import { auto } from '@popperjs/core';
import { ErrorMessageService } from '../services/error-message.service';
import { ToastrService } from 'ngx-toastr';
import { ShareModalComponent } from '../share-modal/share-modal.component';

@Component({
  selector: 'app-property-details',
  templateUrl: './property-details.component.html',
  styleUrls: ['./property-details.component.scss']
})
export class PropertyDetailsComponent implements OnInit {
  listing: any;
  listingData: any;
  currentIndex: number = 0;
  data: any;
  id: number;
  UserDetails: any;
  Images: string[] = [];
  Videos: string[] = [];

  asking: number;
  size: number;
  total: any;
  total1: string;
  sizeUnit: string = '';
  address: any
  postdate: any
  mainImage: string = '';
  galleryImages: string[] = [];
  galleryVideos: string[] = [];
  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private homeService: HomeService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private zone: NgZone,
    private errorMessageService: ErrorMessageService,
    private toastr: ToastrService

  ) { }
  showowner = localStorage.getItem('UserProfile');
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      console.log('params', params);

      this.id = params['id'];
      if (this.id) {
        this.propertById();
      } else {
        console.error('No Property ID found in query params');
      }
    });
  }

  propertById() {
    let fullName = null;
    this.loadingService.show();

    const loginuser = localStorage.getItem('UserProfile');
    console.log(loginuser);


    if (!loginuser && fullName === null && fullName !== undefined) {
      this.homeService.getuserById(this.id).subscribe(
        (response: any) => {
          this.loadingService.hide();
          if (response.status === 'SUCCESS') {
            console.log('response', response);
            this.listingData = response?.payload;
            this.postdate = response.payload.createdAt || '';
            this.UserDetails = response?.payload?.user;
            // this.Images = response.payload.mediaGroup.map((item) => item.url);
            // this.mainImage = this.Images.length ? this.Images[0] : '';
            // this.galleryImages = this.Images.slice(0);
            const mediaGroup = response.payload.mediaGroup || [];
            this.Images = mediaGroup
              .filter(item => item.mediaType === 'IMAGE')
              .map(item => item.url);

            this.Videos = mediaGroup
              .filter(item => item.mediaType === 'VIDEO')
              .map(item => item.url);

            this.mainImage = this.Images.length ? this.Images[0] : '';
            this.galleryImages = this.Images.slice(0);
            this.galleryVideos = this.Videos;
            console.log('listingData', this.listingData);
            this.propertyTyper(this.listingData);
          } else {
            this.listingData = null;
            const errorMessage = this.errorMessageService.getErrorMessage('Failed to fetch user property data');
            this.toastr.error(errorMessage, 'Error');
          }
        },
        (error) => {
          this.loadingService.hide();
          this.listingData = null;

          const message = error?.error?.message || 'Failed to fetch user property data';
          const errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }
      );
    } else {
      this.homeService.getPropertyById(this.id).subscribe(
        (response: any) => {
          this.loadingService.hide();

          if (response.status === 'SUCCESS') {
            console.log('response', response);
            this.listingData = response?.payload;
            this.postdate = response.payload.createdAt || '';
            this.UserDetails = response?.payload?.user;
            const mediaGroup = response.payload.mediaGroup || [];
            this.Images = mediaGroup
              .filter(item => item.mediaType === 'IMAGE')
              .map(item => item.url);

            this.Videos = mediaGroup
              .filter(item => item.mediaType === 'VIDEO')
              .map(item => item.url);

            this.mainImage = this.Images.length ? this.Images[0] : '';
            this.galleryImages = this.Images.slice(0);
            this.galleryVideos = this.Videos.slice(0);
            console.log('listingData', this.listingData);
            this.propertyTyper(this.listingData);
          } else {
            this.listingData = null;
            const errorMessage = this.errorMessageService.getErrorMessage('Failed to fetch property details');
            this.toastr.error(errorMessage, 'Error');
          }
        },
        (error) => {
          this.loadingService.hide();
          this.listingData = null;

          const message = error?.error?.message || 'Failed to fetch property details';
          const errorMessage = this.errorMessageService.getErrorMessage(message);
          this.toastr.error(errorMessage, 'Error');
        }
      );
    }
  }


  propertyTyper(listingData: any) {
    if (listingData.askingUnit === 'Lac') {
      this.total = listingData.asking
    } else if (listingData.askingUnit === 'Cr') {
      this.total = listingData.asking
    }
    // this.asking = listingData.asking;
    // const sizeString = listingData?.feature?.size || '0';
    // const sizeMatch = sizeString.match(/[\d.]+/);
    // this.size = sizeMatch ? parseFloat(sizeMatch[0]) : 0;
    // this.sizeUnit = sizeString.replace(/[\d.]+/, '').trim();

    // if (this.size > 0) {
    //   const totalValue = Math.floor(this.asking / this.size);
    //   this.total = `${totalValue.toLocaleString()} ${this.sizeUnit}`;
    //   this.total1 = `${this.sizeUnit}`;
    // } else {
    //   console.error('Size cannot be zero');
    //   this.total = '0';
    // }
  }



  openContactDetailsDialog(listingData): void {
    const lastdate = localStorage.getItem('UserProfile');
    if (lastdate) {
      this.dialog.open(PropertyOwnerComponent, {
        data: listingData,
        width: '830px',
        height: '500px'
      });
    } else {
      console.log('User is not logged in.');
      this.loginPopup()

    }
  }
  loginPopup() {
    this.dialog.open(LoginPopupComponent, {
      width: '380px',
      height: auto
    });
  }
  parseDate(dateString: string): Date {
    const parts = dateString.split(' ');
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');
    return new Date(
      parseInt(dateParts[2], 10),
      parseInt(dateParts[1], 10) - 1,
      parseInt(dateParts[0], 10),
      parseInt(timeParts[0], 10),
      parseInt(timeParts[1], 10),
      parseInt(timeParts[2], 10)
    );

  }

  ngAfterContentChecked(): void {
  }
  back() {
    window.history.back();
  }




  // galleryImages = [
  //   '../../assets/images/Images_not_found (1).png',
  //   '../../assets/images/Images_not_found (1).png'
  // ];

  // galleryVideos = [
  //   '../../assets/videos/video1.mp4',
  //   '../../assets/videos/video2.mp4'
  // ];

  viewMode: 'image' | 'gallery' | 'video' = 'image';

  selectedImage: string | null = null;
  isImageModalOpen = false;

  selectedVideo: string | null = null;
  isVideoModalOpen = false;

  openImageModal(img: string): void {
    // this.selectedImage = img;
    // this.isImageModalOpen = true;
      this.mainImage = img;
  }

  closeImageModal(): void {
    this.isImageModalOpen = false;
    this.selectedImage = null;
  }

  openVideoModal(video: string): void {
    this.selectedVideo = video;
    this.isVideoModalOpen = true;
  }

  closeVideoModal(): void {
    this.isVideoModalOpen = false;
    this.selectedVideo = null;
  }
  toggleGallery(): void {
    this.viewMode = this.viewMode === 'gallery' ? 'image' : 'gallery';
  }
  toggleVideo(): void {
    this.viewMode = this.viewMode === 'video' ? 'image' : 'video';
  }
hasAmenity(name: string): boolean {
  return this.listingData?.amenities?.includes(name);
}
  defaultImage: string = 'https://example.com/path/to/default-image.jpg';

 openShareModal(listing:any): void {
  console.log('listing details',listing);

  this.dialog.open(ShareModalComponent, {
    width: '440px',
    panelClass: 'custom-blue-background',
    data: {
      // listingUrl: this.listingUrl,
      listingTitle: this.listing?.title,
      listingDescription: this.listing?.description,
      listingArea:this.listing?.area,
      listingPrice:this.listing?.propertyRentPrice,
      listingaddress:this.listing?.address,
      listingcityName:this.listing?.cityName,
      listingImage: this.Images.length > 0 ? this.Images[0] : this.defaultImage,
    }
  });
  }
  isPopupOpen :boolean=false;

  closeSharePopup() {
    this.isPopupOpen = false;
  }
}
